import { render, staticRenderFns } from "./BrbForm.vue?vue&type=template&id=62ab9382&"
import script from "./BrbForm.vue?vue&type=script&lang=js&"
export * from "./BrbForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/panel/driver/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62ab9382')) {
      api.createRecord('62ab9382', component.options)
    } else {
      api.reload('62ab9382', component.options)
    }
    module.hot.accept("./BrbForm.vue?vue&type=template&id=62ab9382&", function () {
      api.rerender('62ab9382', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/brb-components/BrbForm.vue"
export default component.exports